import React from "react";
import PropTypes from "prop-types";
import Stack from "@mui/material/Stack";

const SFStack = ({
  children,
  spacing,
  direction = "column",
  alignItems,
  justifyContent,
  ...props
}) => (
  <Stack
    alignItems={alignItems}
    justifyContent={justifyContent}
    direction={direction}
    spacing={spacing}
    {...props}
  >
    {children}
  </Stack>
);

SFStack.propTypes = {
  direction: PropTypes.oneOf([
    "row",
    "row-reverse",
    "column",
    "column-reverse",
  ]),
  children: PropTypes.node,
  spacing: PropTypes.number,
  alignItems: PropTypes.oneOf([
    "flex-start",
    "center",
    "flex-end",
    "stretch",
    "baseline",
  ]),
  justifyContent: PropTypes.oneOf([
    "flex-start",
    "center",
    "flex-end",
    "space-between",
    "space-around",
    "space-evenly",
  ]),
};

export default SFStack;
